$('document').ready(function () {

  'use strict';

  const maxFileSize = 5242880; // 5 Mb
  const fileSizeError = 'Zbyt duży plik i nie zostanie dołączony';

  // Scroll the active sidebar link into view - EXAMPLE !!!!
  // const sidenav = document.querySelector('.bd-sidebar')
  // if (sidenav) {
  //   const sidenavHeight = sidenav.clientHeight
  //   const sidenavActiveLink = document.querySelector('.bd-links-nav .active')
  //   const sidenavActiveLinkTop = sidenavActiveLink.offsetTop
  //   const sidenavActiveLinkHeight = sidenavActiveLink.clientHeight
  //   const viewportTop = sidenavActiveLinkTop
  //   const viewportBottom = viewportTop - sidenavHeight + sidenavActiveLinkHeight
  //
  //   if (sidenav.scrollTop > viewportTop || sidenav.scrollTop < viewportBottom) {
  //     sidenav.scrollTop = viewportTop - (sidenavHeight / 2) + (sidenavActiveLinkHeight / 2)
  //   }
  // }


  // const mainCarousel = document.querySelector('.main-carousel');
  // if (mainCarousel) {
  //   console.log(mainCarousel)
  // $(mainCarousel).slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   dots: true,
  //   focusOnSelect: true,
  //   autoplay: false,
  //   autoplaySpeed: 2000
  // });
  // }

  /*
    FORM custom attachemnt field
   */
  const input_add_attachemnt_file = document.querySelector('.add_attachment_file .input');

  if (null !== input_add_attachemnt_file) {
    let file_attachment_trigger = document.querySelector('#contactFormFileAttachement');
    input_add_attachemnt_file.addEventListener('click', () => {
      file_attachment_trigger.click();
    });
  }
  /*
    FORM custom checkbox field
   */
  const form_check_input_custom = document.querySelector('.form-check-input-custom');
  if (null !== form_check_input_custom) {
    form_check_input_custom.addEventListener('click', () => {
      form_check_input_custom.nextElementSibling.click();
    });

    $('.wpcf7-list-item-label').on('click', function () {
      $(this).parents('.form-check').find('.form-check-input-custom').toggleClass('checked');
    });
    $('.form-check-input-custom').on('click', function () {
      $(this).parents('.form-check').find('.wpcf7-list-item-label').click();
    });
  }

  /*
    FROM validation
   */
  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  let forms = document.querySelectorAll('.needs-validation');


  $('input[name=file]').on('change', function () {
    let size = this.files[0].size;
    if (size > maxFileSize) {
      $(this).next().next().text(fileSizeError).show();
      $(this).parents('.form.needs-validation').addClass('was-validate');
    } else {
      $(this).next().next().hide();
    }

  });

  Array.prototype.slice.call(forms)
    .forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();

        } else {


          console.log($(form).serialize());


        }

        form.classList.add('was-validated');
      }, false);
    });


  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // function eraseCookie(name) {
  //   document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  // }

  const cookieExist = getCookie('cookieBar');
  const cookieBar = document.querySelector('#cookieInfoSection');

  if (cookieExist === null) {
    cookieBar.style.display = 'block';

    const cookieBtn = document.querySelector('#cookieAgree');
    cookieBtn.addEventListener('click', function () {
      setCookie('cookieBar', new Date().toLocaleString(), 1);
      cookieBar.style.display = 'none';
    });

  }
  const linkLabelAgree = document.querySelector('label a.link-quite');
  if (null !== linkLabelAgree) {
    linkLabelAgree.addEventListener('click', function () {
      $(this).parent('span').off('click')
    });
  }

});
